import { useState } from "react";
import { toast } from "sonner";
import { Phone, MapPin } from "lucide-react";
import PageShell from "@/components/PageShell";
import { api } from "@/lib/api";

const inputCls = "w-full border-2 border-slate-200 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-brand-orange transition-colors";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
    const [sending, setSending] = useState(false);
    const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

    async function send(e) {
        e.preventDefault();
        if (!form.name.trim() || !/^\S+@\S+\.\S+$/.test(form.email) || !form.message.trim()) {
            toast.error("Please fill in name, valid email, and message");
            return;
        }
        setSending(true);
        try {
            await api.post("/contact", form);
            toast.success("Message sent — we'll be in touch soon.");
            setForm({ name: "", email: "", phone: "", subject: "", message: "" });
        } catch {
            toast.error("Failed to send. Please call us instead.");
        } finally {
            setSending(false);
        }
    }

    return (
        <PageShell>
            <section className="bg-brand-navy text-white py-16">
                <div className="max-w-5xl mx-auto px-6 md:px-12">
                    <div className="text-xs uppercase tracking-[0.3em] text-brand-orange font-bold mb-4">Get in Touch</div>
                    <h1 className="font-heading text-4xl md:text-6xl font-black uppercase">Questions? Let's talk.</h1>
                </div>
            </section>
            <section className="max-w-5xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-10">
                <div className="space-y-6">
                    <div className="flex gap-3"><Phone className="h-5 w-5 text-brand-orange mt-1" /><div><div className="font-heading font-bold uppercase text-sm tracking-wider text-brand-navy">Phone</div><div className="text-slate-600">260.483.7085</div></div></div>
                    <div className="flex gap-3"><MapPin className="h-5 w-5 text-brand-orange mt-1" /><div><div className="font-heading font-bold uppercase text-sm tracking-wider text-brand-navy">Office</div><div className="text-slate-600">1501 Goshen Ave.<br />Fort Wayne, IN</div></div></div>
                </div>
                <form onSubmit={send} className="md:col-span-2 border-2 border-slate-200 p-6 md:p-8 space-y-4" data-testid="contact-form">
                    <div className="grid sm:grid-cols-2 gap-4">
                        <input className={inputCls} placeholder="Full name *" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="contact-name" />
                        <input className={inputCls} type="email" placeholder="Email *" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="contact-email" />
                        <input className={inputCls} placeholder="Phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="contact-phone" />
                        <input className={inputCls} placeholder="Subject" value={form.subject} onChange={(e) => set("subject", e.target.value)} data-testid="contact-subject" />
                    </div>
                    <textarea className={inputCls} rows={6} placeholder="How can we help? *" value={form.message} onChange={(e) => set("message", e.target.value)} data-testid="contact-message" />
                    <button type="submit" disabled={sending} className="bg-brand-orange hover:bg-brand-navy text-white font-heading uppercase tracking-wider font-bold px-6 py-3 rounded-sm disabled:opacity-60 transition-colors" data-testid="contact-submit-btn">
                        {sending ? "Sending..." : "Send Message"}
                    </button>
                </form>
            </section>
        </PageShell>
    );
}
